module.exports = __webpack_public_path__ + "img/NOTE.b2b53fec.svg";